import React from 'react'

import clsx from 'clsx'

import { MdContentRenderer } from 'src/common/components/MdContentRenderer/MdContentRenderer'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { ArticleOrStoryLayout } from 'src/common/layouts/ArticleOrStoryLayout/ArticleOrStoryLayout'
import { ArticleClientType } from 'src/strapi/types/articleTypes'

import s from './ArticleMain.module.scss'

export type ArticleMainProps = {
  article: ArticleClientType
}

export const ArticleMain: React.FC<ArticleMainProps> = ({ article }) => (
  <section className={clsx(s.ArticleMain, 'container')}>
    <Typography
      variant={EnumTypographyVariants.H2}
      className={s.ArticleMain__title}
      text={article.title}
      as="h1"
    />

    <ArticleOrStoryLayout>
      <MdContentRenderer content={article.text} />
    </ArticleOrStoryLayout>
  </section>
)
